import { TApplicationState } from '../../types/redux';

export function getFullAddress(state: TApplicationState) {
  const {
    newbuilding: { fullAddress },
  } = state;

  return fullAddress;
}
